(($) => {

    if ($('.js-vivus').length) {
        new Vivus('vivus', {
            type: 'delayed',
            duration: 200
        })
    }

})(jQuery)